import { NavLink } from "react-router-dom";
import { Wallet } from "lucide-react";
import { shortWallet, useApi } from "../../dashboard/api";
import { NAV_GROUPS } from "../../dashboard/nav";
import { Skeleton } from "./ui";

const linkClass = (isActive) =>
    `group relative flex items-center gap-3 rounded-lg px-3 py-2 text-[13px] font-semibold transition-colors duration-200 ${
        isActive ? "bg-white/[0.04] text-nx-text" : "text-nx-mute hover:bg-white/[0.02] hover:text-nx-sub"
    }`;

export const SidebarContent = ({ onNavigate }) => {
    const { data, loading } = useApi("summary");
    return (
        <div className="flex h-full flex-col">
            <div className="flex h-16 items-center px-5">
                <a href="/" data-testid="sidebar-logo" aria-label="Nexora Global home">
                    <img src="/assets/nexora-logo.png" alt="Nexora Global" className="h-6 w-auto" />
                </a>
            </div>

            <nav className="flex-1 space-y-6 overflow-y-auto px-3 py-4" aria-label="Dashboard">
                {NAV_GROUPS.map((group) => (
                    <div key={group.label}>
                        <p className="px-3 pb-2 text-[10px] font-bold uppercase tracking-[0.2em] text-nx-mute/70">
                            {group.label}
                        </p>
                        <div className="space-y-0.5">
                            {group.items.map((item) => (
                                <NavLink
                                    key={item.to}
                                    to={item.to}
                                    end={item.end}
                                    onClick={onNavigate}
                                    data-testid={`sidebar-${item.label.toLowerCase()}`}
                                    className={({ isActive }) => linkClass(isActive)}
                                >
                                    {({ isActive }) => (
                                        <>
                                            <span
                                                className={`absolute left-0 top-1/2 h-4 w-0.5 -translate-y-1/2 rounded-full bg-nx-lime transition-opacity duration-200 ${isActive ? "opacity-100" : "opacity-0"}`}
                                                aria-hidden="true"
                                            />
                                            <item.icon
                                                size={16}
                                                strokeWidth={1.5}
                                                className={isActive ? "text-nx-lime" : "text-nx-mute transition-colors duration-200 group-hover:text-nx-sub"}
                                                aria-hidden="true"
                                            />
                                            {item.label}
                                        </>
                                    )}
                                </NavLink>
                            ))}
                        </div>
                    </div>
                ))}
            </nav>

            <div className="border-t border-white/5 px-5 py-4" data-testid="sidebar-wallet">
                <div className="flex items-center gap-2.5">
                    <span className="flex h-8 w-8 items-center justify-center rounded-lg border border-white/5 bg-nx-soft text-nx-sub">
                        <Wallet size={14} strokeWidth={1.5} aria-hidden="true" />
                    </span>
                    <div className="min-w-0">
                        <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-nx-mute">Connected Wallet</p>
                        {loading || !data ? (
                            <Skeleton className="mt-1 h-3 w-24" />
                        ) : (
                            <p className="mt-0.5 font-mono text-xs font-semibold text-nx-text" data-testid="sidebar-wallet-address">
                                {shortWallet(data.user.wallet)}
                            </p>
                        )}
                    </div>
                </div>
                <p className="mt-2.5 flex items-center gap-1.5 text-[11px] font-semibold text-nx-mute">
                    <span className="h-1.5 w-1.5 rounded-full bg-nx-lime" aria-hidden="true" />
                    BNB Smart Chain
                </p>
            </div>
        </div>
    );
};

export const Sidebar = () => (
    <aside className="fixed inset-y-0 left-0 z-40 hidden w-60 border-r border-white/5 bg-nx-ink lg:block" data-testid="sidebar">
        <SidebarContent />
    </aside>
);
